import { createCrudApi } from './crud';

export interface Material {
  id: number;
  materialCode: string;
  materialDescription: string;
  category: string | null;
  unit: string;
  hsnCode: string | null;
  status: 'active' | 'inactive';
  createdAt: string;
}

export interface CreateMaterialInput {
  materialDescription: string;
  category?: string;
  unit: string;
  hsnCode?: string;
  status?: 'active' | 'inactive';
}

export const materialsApi = createCrudApi<Material, CreateMaterialInput>('materials');
